import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../services/interfaces';
import { translateEntity } from '../../../services/utils';

import { MatchDate } from './components';
import { casesPrintPhase, getMatchWording, isLiveMatchPenalties, statusIsPrintable } from './helpers';
import {
  isFinishedMatch,
  isLiveMatch,
  isSizePlus,
  isUpcomingMatch,
  phaseIsPrintable,
  setCssVariant,
} from './helpers/match-unit.helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchUnitVerticalMiddleLeft = ({ state }: Props) => {
  const size = state.size;
  const cssVariant = setCssVariant(size);
  const match = state.matchData;

  const isUpcoming = isUpcomingMatch(match.status);
  const isLive = isLiveMatch(match.status);
  const isLivePenalties = isLiveMatchPenalties(match.status, match.phase);
  const isLiveAndNoPenalties = isLive && !isLivePenalties && !casesPrintPhase.includes(match.phase);

  const isPlusSize = isSizePlus(size);

  return (
    <div class="left" part="left">
      {isUpcoming && <MatchDate state={state} />}
      {isLiveAndNoPenalties && !isPlusSize && (
        // Normal live indicator with the live text
        <span class={{ 'mu__vertical--live': true, ...cssVariant }} part="live">
          {getMatchWording(match?.status.toLowerCase())}
        </span>
      )}
      {isLivePenalties && !isPlusSize && (
        <span class={{ 'mu__vertical--live': true, ...cssVariant }} part="live">
          {translateEntity(match)?.phaseName}
        </span>
      )}
      {phaseIsPrintable(match) && !isLivePenalties && (
        <span class={{ 'pk-match__status--phase': true, ...cssVariant }} part="status-phase">
          {translateEntity(match)?.phaseName}
        </span>
      )}
      {statusIsPrintable(match) && (
        <span class={{ 'pk-match__status--cp': true, ...cssVariant }} part="status-cp">
          {getMatchWording(match.status.toLowerCase())}
        </span>
      )}
      {isFinishedMatch(match.status) && (
        <span class={{ 'mu__full-time': true, ...cssVariant }} part="full-time">
          {getMatchWording('full_time')}
        </span>
      )}
    </div>
  );
};

export { MatchUnitVerticalMiddleLeft };
